<template>
  <DialogCard>
    <template #title>
      Consent
    </template>
    <template #text>
      <p>
        neuralike’s mission is to help people access, understand, and benefit from their medical
        images. An important aspect of how we can achieve this is our research program.
      </p>
      <p>
        We invite you to take part in this program. To get started, you must agree to the terms in
        this consent document.
      </p>
      <p>
        You give us permission to receive invitations to take surveys or otherwise enter information
        about yourself into neuralike’s website. You choose which surveys to take and which
        questions to answer. By taking surveys, you may learn about neuralike's research findings,
        including how your answers compare with those of others and new discoveries made by
        neuralike's research program.
      </p>
      <p>
        You give us permission to use for our research your medical-imaging data and any other
        personal information you enter into the website, except for your registration information
        (i.e., name, contact information, and credit card information).
      </p>
      <p>
        You give us permission to share your de-identified individual-level medical-image
        information with research collaborators outside of neuralike. We work with these
        collaborators to study many different topics including predictors of diseases, connections
        among diseases and traits, and how people react to their personal medical information.
      </p>
      <p>
        There is a very small chance that someone with access to the research data or results could
        expose personal information about you. neuralike has policies and practices in place to
        minimize the chance of such an event.
      </p>
      <p>
        You can withdraw from neuralike’s research at any time. Any of your data that have already
        been entered into a study cannot be withdrawn, but your data will not be included in studies
        that start more than 30 days after you withdraw.
      </p>
      <p>
        If you have general questions or need help with neuralike's service, please go to
        <a>this web page</a>.
      </p>
    </template>
  </DialogCard>
</template>

<script>
import DialogCard from '@/layout/BottomDrawer/DialogCard.vue';

export default {
  name: 'NeuralikeConsentDialog',
  components: {
    DialogCard,
  },
};
</script>
